export default __webpack_public_path__ + "static/media/fee-collection.d68337aa.svg";